/**
* Testimonial Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonial Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'testimonial-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.testimonial-slider' ).each( function( key, component ) {
        const testimonialsSplide = new Splide( $( component ).find( '.testimonial-slider__slider' )[0], {
          type: 'loop',
          pagination: false,
          arrows: true,
          gap: '32px',
          perPage: 1,
          autoWidth: false,
          autoplay: true,
          interval: 6000,
        } );

        const imagesSplide = new Splide( $( component ).find( '.testimonial-slider__slider-images' )[0], {
          type: 'loop',
          pagination: false,
          arrows: false,
          autoWidth: false,
          perPage: 1,
        } );

        testimonialsSplide.sync( imagesSplide );
        testimonialsSplide.mount();
        imagesSplide.mount();

        // testimonialsSplide.on( 'overflow', function( isOverflow ) {
        //   testimonialsSplide.options = {
        //     arrows: isOverflow,
        //     drag: isOverflow,
        //   };
        // } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'testimonial-slider', COMPONENT );
} )( app );
